
export const STATUS_COLOR = {
  red: '#FF0606',
  orange: '#FF8B06',
  black: '#333333',
};

export const PERMISSION_LIST_COLOR = {
  orange: '#F59E47',
  pink: '#E58E8E'
};

export const NOTIFICATIONS_STATUS = {
  0: {
    name: 'STATUS.TEST_SEND',
    color: STATUS_COLOR.orange,
  },
  1: {
    name: 'STATUS.SENT',
    color: STATUS_COLOR.red,
  },
};

export const PERMISSION_LIST = {
  0: {
    name: 'PERMISSION_LIST.SYS_ADMIN',
    color: PERMISSION_LIST_COLOR.orange,
    roleId: 1,
  },
  1: {
    name: 'PERMISSION_LIST.ALL_ROLE',
    color: PERMISSION_LIST_COLOR.pink,
    roleId: 2,
  }
};

export const NOTIFICATIONS_DETAIL_STATUS = {
  0: {
    name: 'STATUS.SEND_FAILED',
    color: STATUS_COLOR.red,
    searchKey: '失敗',
  },
  1: {
    name: 'STATUS.RECEIVE',
    color: STATUS_COLOR.black,
    searchKey: '成功',
  },
};
